import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RentControlState } from '../../../@types/state-types'

export const initialState: RentControlState = {
  isPending: false,
  city: undefined,
  rentControlApplies: undefined,
}

const rentControlFeatureSlice = createSlice({
  name: 'rentControlFeature',
  initialState,
  reducers: {
    rentControlRequest(state) {
      state.isPending = true
    },
    rentControlSuccess(state, action: PayloadAction<{ city: string; rentControlApplies: boolean | null }>) {
      state.city = action.payload.city
      state.rentControlApplies = action.payload.rentControlApplies
    },
    rentControlReset(state) {
      state.isPending = false
      state.city = undefined
      state.rentControlApplies = undefined
    },
    rentControlRequestCompleted(state) {
      state.isPending = false
    },
  },
})

export const { rentControlRequest, rentControlSuccess, rentControlReset, rentControlRequestCompleted } =
  rentControlFeatureSlice.actions
export default rentControlFeatureSlice.reducer
